'use client';

var ALLOW_SEARCHABLE = 1;
var INTERN_LEVEL = 1;
var FRESHER_LEVEL = 8;
var MANAGER_LEVEL = 7;
var DIRECTOR_LEVEL = 3;

export { ALLOW_SEARCHABLE, DIRECTOR_LEVEL, FRESHER_LEVEL, INTERN_LEVEL, MANAGER_LEVEL };
//# sourceMappingURL=const.js.map
